import { Link } from "react-router-dom";
import React from "react";
import logo from "../img/logo/logo300.png"

export default function Footer(){
    return (
        <>

            <footer>

                <div className="footerDiv">
                    
                    <img src={logo} alt="logoOutai"/>
                    <Link to="/privacy" style={{fontStyle:"italic", textDecoration:""}}>Informativa sulla privacy</Link>
                </div>

                <div className="footerDiv">
                    <h3>Venite a trovarci!</h3>
                    <p>Grazie</p>
                </div>

                <div className="footerDiv">
                    <h3>Email:</h3>
                    <p>outaitrading@gmail.com</p>
                </div>
                
            </footer>
            <p id="copyright" style={{color:"white",backgroundColor:"black",textAlign:"center",padding:"10px"}}>Copyright © 2023. Outai Tranding All rights reserved.</p>
        </>


    )
}